var map = {
	"./brands/bigpass_logo_minimized.png": "./src/assets/brands/bigpass_logo_minimized.png",
	"./brands/bitbucket.jpg": "./src/assets/brands/bitbucket.jpg",
	"./brands/dropbox.png": "./src/assets/brands/dropbox.png",
	"./brands/figma.png": "./src/assets/brands/figma.png",
	"./brands/firebase.png": "./src/assets/brands/firebase.png",
	"./brands/firebase.svg": "./src/assets/brands/firebase.svg",
	"./brands/firebase.webp": "./src/assets/brands/firebase.webp",
	"./brands/harezmi-arge.png": "./src/assets/brands/harezmi-arge.png",
	"./brands/mailchimp.jpg": "./src/assets/brands/mailchimp.jpg",
	"./brands/matercard-2.png": "./src/assets/brands/matercard-2.png",
	"./brands/matercard.png": "./src/assets/brands/matercard.png",
	"./brands/mergen logo.png": "./src/assets/brands/mergen logo.png",
	"./brands/mergen_logo.png": "./src/assets/brands/mergen_logo.png",
	"./brands/mixpanel.png": "./src/assets/brands/mixpanel.png",
	"./brands/mixpanel.webp": "./src/assets/brands/mixpanel.webp",
	"./brands/slack.png": "./src/assets/brands/slack.png",
	"./brands/trello.png": "./src/assets/brands/trello.png",
	"./browsers/brave.svg": "./src/assets/browsers/brave.svg",
	"./browsers/chrome.png": "./src/assets/browsers/chrome.png",
	"./browsers/edge.png": "./src/assets/browsers/edge.png",
	"./browsers/firefox.png": "./src/assets/browsers/firefox.png",
	"./browsers/opera.png": "./src/assets/browsers/opera.png",
	"./browsers/safari.png": "./src/assets/browsers/safari.png",
	"./countries/alemanha.png": "./src/assets/countries/alemanha.png",
	"./countries/argentina.png": "./src/assets/countries/argentina.png",
	"./countries/brasil-lg.png": "./src/assets/countries/brasil-lg.png",
	"./countries/china.png": "./src/assets/countries/china.png",
	"./countries/espanha-lg.png": "./src/assets/countries/espanha-lg.png",
	"./countries/espanha.png": "./src/assets/countries/espanha.png",
	"./countries/estados-unidos-lg.png": "./src/assets/countries/estados-unidos-lg.png",
	"./countries/frança.png": "./src/assets/countries/frança.png",
	"./countries/italia-lg.png": "./src/assets/countries/italia-lg.png",
	"./extensions/audio-box.jpg": "./src/assets/extensions/audio-box.jpg",
	"./extensions/audio-box.png": "./src/assets/extensions/audio-box.png",
	"./extensions/audio.png": "./src/assets/extensions/audio.png",
	"./extensions/excel.png": "./src/assets/extensions/excel.png",
	"./extensions/pdf-2.png": "./src/assets/extensions/pdf-2.png",
	"./extensions/pdf.png": "./src/assets/extensions/pdf.png",
	"./extensions/picture.png": "./src/assets/extensions/picture.png",
	"./extensions/play.png": "./src/assets/extensions/play.png",
	"./extensions/txt.png": "./src/assets/extensions/txt.png",
	"./extensions/video.png": "./src/assets/extensions/video.png",
	"./extensions/word.png": "./src/assets/extensions/word.png",
	"./extras/arquivo-corrompido.png": "./src/assets/extras/arquivo-corrompido.png",
	"./extras/background.png": "./src/assets/extras/background.png",
	"./extras/backgrount.jpg": "./src/assets/extras/backgrount.jpg",
	"./extras/chat.jpg": "./src/assets/extras/chat.jpg",
	"./extras/chat.png": "./src/assets/extras/chat.png",
	"./extras/corrupted-file.png": "./src/assets/extras/corrupted-file.png",
	"./extras/css-3.png": "./src/assets/extras/css-3.png",
	"./extras/doc.png": "./src/assets/extras/doc.png",
	"./extras/git.png": "./src/assets/extras/git.png",
	"./extras/golang.png": "./src/assets/extras/golang.png",
	"./extras/html.png": "./src/assets/extras/html.png",
	"./extras/image-1.jpg": "./src/assets/extras/image-1.jpg",
	"./extras/image-2.jpg": "./src/assets/extras/image-2.jpg",
	"./extras/image-3.jpg": "./src/assets/extras/image-3.jpg",
	"./extras/image-4.jpg": "./src/assets/extras/image-4.jpg",
	"./extras/image-5.jpg": "./src/assets/extras/image-5.jpg",
	"./extras/image-6.jpg": "./src/assets/extras/image-6.jpg",
	"./extras/javascript.png": "./src/assets/extras/javascript.png",
	"./extras/pdf.png": "./src/assets/extras/pdf.png",
	"./extras/python.png": "./src/assets/extras/python.png",
	"./extras/unplugged.png": "./src/assets/extras/unplugged.png",
	"./extras/xls.png": "./src/assets/extras/xls.png",
	"./files/Atividade 2 - Faxina Financeira.xlsx": "./src/assets/files/Atividade 2 - Faxina Financeira.xlsx",
	"./files/Visao Do Sistema Plus Car.docx": "./src/assets/files/Visao Do Sistema Plus Car.docx",
	"./files/atlassian-git-cheatsheet.pdf": "./src/assets/files/atlassian-git-cheatsheet.pdf",
	"./files/audio/dark-future-logo-196217.mp3": "./src/assets/files/audio/dark-future-logo-196217.mp3",
	"./files/audio/inspiring-trailer-15-sec-203615.mp3": "./src/assets/files/audio/inspiring-trailer-15-sec-203615.mp3",
	"./files/bebida-soda-vidro.mp4": "./src/assets/files/bebida-soda-vidro.mp4",
	"./files/boat-7092.mp4": "./src/assets/files/boat-7092.mp4",
	"./files/chill-abstract-intention-12099.mp3": "./src/assets/files/chill-abstract-intention-12099.mp3",
	"./files/esfera-forma.mp4": "./src/assets/files/esfera-forma.mp4",
	"./files/git cheatsheet.docx": "./src/assets/files/git cheatsheet.docx",
	"./files/nature.mp4": "./src/assets/files/nature.mp4",
	"./files/pianchette-top.jpeg": "./src/assets/files/pianchette-top.jpeg",
	"./files/regex_cheatsheet.pdf": "./src/assets/files/regex_cheatsheet.pdf",
	"./files/rocks-82.jpeg": "./src/assets/files/rocks-82.jpeg",
	"./files/squirrel-82.jpeg": "./src/assets/files/squirrel-82.jpeg",
	"./files/tags.txt": "./src/assets/files/tags.txt",
	"./files/um-arquivo-simples.txt": "./src/assets/files/um-arquivo-simples.txt",
	"./files/um-olhar-profundo.txt": "./src/assets/files/um-olhar-profundo.txt",
	"./icons/avatar-square.png": "./src/assets/icons/avatar-square.png",
	"./icons/avatar.png": "./src/assets/icons/avatar.png",
	"./icons/bing.png": "./src/assets/icons/bing.png",
	"./icons/check_box.svg": "./src/assets/icons/check_box.svg",
	"./icons/check_box_outline_blank.svg": "./src/assets/icons/check_box_outline_blank.svg",
	"./icons/exclamation.png": "./src/assets/icons/exclamation.png",
	"./icons/facebook.png": "./src/assets/icons/facebook.png",
	"./icons/google.png": "./src/assets/icons/google.png",
	"./icons/instagram.png": "./src/assets/icons/instagram.png",
	"./icons/microsoft.png": "./src/assets/icons/microsoft.png",
	"./icons/safari.png": "./src/assets/icons/safari.png",
	"./icons/warning.png": "./src/assets/icons/warning.png",
	"./logos/asdas.png": "./src/assets/logos/asdas.png",
	"./logos/logo-1.png": "./src/assets/logos/logo-1.png",
	"./logos/logo-2.png": "./src/assets/logos/logo-2.png",
	"./logos/logo-3.png": "./src/assets/logos/logo-3.png",
	"./logos/xz.png": "./src/assets/logos/xz.png",
	"./svg/chat.svg": "./src/assets/svg/chat.svg",
	"./svg/undraw_feeling_blue.svg": "./src/assets/svg/undraw_feeling_blue.svg",
	"./svg/undraw_search.svg": "./src/assets/svg/undraw_search.svg",
	"./users/14.png": "./src/assets/users/14.png",
	"./users/beatriz.jpg": "./src/assets/users/beatriz.jpg",
	"./users/carolina.avif": "./src/assets/users/carolina.avif",
	"./users/emmilly.jpg": "./src/assets/users/emmilly.jpg",
	"./users/jennyfer.jpg": "./src/assets/users/jennyfer.jpg",
	"./users/menina.png": "./src/assets/users/menina.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets sync recursive ^\\.\\/.*$";